import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Wallet {
  createdAt: string;
  history: any[];
}

enum DocumentType {
  CC = "CC",
  CE = "CE",
  PASSPORT = "PASSPORT",
}

export interface Network {
  wallet: Wallet;
  bonds: any[];
  activate_date?: string;
  influencer_bonus_finish_date?: string;
  influencer_bonus_status?: boolean;
  loyalty_finish_date?: string;
  loyalty_status?: boolean;
  rank_id: string;
}

export interface UserNetwork {
  user_id: string;
  network_status: boolean;
  level: number;
  _id: string;
  id: string;
}

export interface Parent {
  id: string;
  name: string;
  email: string;
  photo: string;
  createdAt: string;
}


export interface IUserBankAccount {
  bankCode: string;                 // "007", "507", "551", etc.
  accountType: 1 | 2 | 3 | 4 | 5;       // 1: corriente, 2: ahorros, 4: celular, 5: Bre-b
  accountNumber: string;            // cuenta o número de celular
  accountHolderName: string;        // Nombre completo del titular
  identificationType: "CC" | "CE" | "NIT" | "PASSPORT" | "PPT";  // Tipo de documento: CC, CE, NIT, PASSPORT, PPT
  identificationNumber: string;
  acceptedTerms: boolean;           // Si aceptó términos    
}

export interface User {
  id: string;
  name: string;
  email: string;
  cellphone: number | string; // Puede ser número o string según la API
  dateOfBirth: string;
  gender: string;
  city: string;
  documentType?: DocumentType;
  document: string;
  photo: string;
  province: string;
  is_confirmed: boolean;
  role: string;
  status: boolean;
  country_id: string;
  multyhealth_code: string;
  reference_id: string;
  createdAt: string;
  updatedAt: string;
  network: Network;
  user_network: UserNetwork[];
  token?: string;
  parent?: Parent;
  country?: Country
  subscription?: boolean;
  rank_id?: string;
  rutDocument?: string;
  identityDocument?: string;
  bankCertificate?: string;
  bankAccount?: IUserBankAccount;
  acceptedTerms: boolean;
}

export interface Country {
  country_id: string;
  name: string;
  paymentGateways: string[];
  currency: string;
  pointValue: number;
  status: boolean;
  created_at: string;
  createdAt: string;
  updatedAt: string;
  id: string;
}


interface UserState {
  user: User | null;
  isAuthenticated: () => boolean;
  setUser: (user: User) => void;
  updateUser: (data: Partial<User>) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set, get) => ({
      user: null,

      isAuthenticated: () => !!get().user?.token,

      setUser: (user) => {
        set({ user });
      },

      updateUser: (data) => {
        const { user } = get();
        if (user) {
          set({ user: { ...user, ...data } });
        }
      },

      clearUser: () => {
        set({ user: null });
      }
    }),
    {
      name: 'multyhealth-user',
      partialize: (state) => ({ user: state.user }),
    }
  )
);
